import moment from 'moment-timezone';

export const SHOPPABLE_CATEGORY_ID = 'pl';
export const SHOPPABLE_TOPIC_NAME = 'product links';

export const TEMPLATE_CATEGORIES = [
  { id: 'pw', name: 'Pre-written' },
  { id: 'fitb', name: 'Fill-in-the-Blank' },
  { id: SHOPPABLE_CATEGORY_ID, name: 'Product Links' },
];

export const DEFAULT_TEMPLATE = {
  message: '',
  topic: '',
  subtopic: '',
  source: null,
  cesdk_scene: null,
  cesdk_scene_metadata: null,
  type: 'text',
  category: 'pw',
  created_source: 'desktop',
  link: '',
  cta: '',
  title: '',
  description: '',
};

/**
 * Returns true when the template is a video backed by a CE.SDK scene.
 */
export function isEditableVideoTemplate(template = {}) {
  return template?.type === 'video' && Boolean(template?.cesdk_scene);
}

export function clearEditableVideoFields(template) {
  return {
    ...template,
    source: null,
    picture: null,
    cesdk_scene: null,
    cesdk_scene_metadata: null,
    type: 'text',
  };
}

/**
 * Drops the CE.SDK scene and its static thumbnail so uploaded media
 * replacing an editable video doesn't keep the editable video picture.
 */
export function withoutCesdkSceneFields(template) {
  return {
    ...template,
    picture: null,
    cesdk_scene: null,
    cesdk_scene_metadata: null,
  };
}

export const DEFAULT_TOPIC = {
  name: '',
  category: 'template',
};

export function getInitialDate(date) {
  return date ? moment.tz(date, 'America/Chicago') : null;
}

export function createEmptyTemplate(overrides = {}) {
  return { ...DEFAULT_TEMPLATE, ...overrides };
}
